import mitt from 'mitt'

export const emitter = mitt()

export const EVENTS = {
  LOADER: {
    ENDED: 'ended'
  },
  HEADER: {
    HIDE: 'hide-header',
    MOBILE_NAV: 'mobile-nav',
    MINIMIZE: 'minimize'
  }
}
